export var allowedAttributes = {
  '*': ['style', 'class', 'id', 'alt', 'title'],
  a: ['href', 'name', 'target'],
  img: ['src'],
  video: ['src', 'poster', 'controls', 'preload', 'autoplay'],
  audio: ['src', 'controls', 'preload', 'autoplay']
};
export var allowedTags = ['img', 'span', 'strong', 'em', 'b', 'p', 'video', 'u', 'audio'];
export var showErrorQuestIds = [21495, 21488, 24596, 24594, 24597, 26653, 24593, 24590, 24589, 24592, 24591, 24598];
export var getNewH5HTML = "html {\n    --primary-color: #3370ff !important;\n    --text-color: #161823 !important;\n    --text-color-secondary: #70757C;\n    --text-color-thirdly: #A8ACB3;\n    --text-red: #FE2C55;\n    --bg-gray: #f5f6fa;\n    --border-gray: #dee0e3;\n    --border-gray-secondary: #ecedf0;\n    --border-gray-mobile: #F0F2F8;\n    --question-bg: #fff;\n    --ant-table-border: #e7e7e7;\n    --ant-table-hover: #f0f7ff; //pc table hover\u80CC\u666F\u8272\n    --ant-bg:#fff; // antd\u63A7\u4EF6\u80CC\u666F\u8272\n    --ant-border:rgba(22, 24, 35, 0.34); // antd\u63A7\u4EF6\u8FB9\u6846\n    --ant-entity-bg: #eef0f5; //antd\u63A7\u4EF6\u9700\u8981\u80CC\u666F\u8272\u7684\u9ED8\u8BA4\u586B\u5145\n    --am-entity-bg: #eef0f5;\n    --ant-entity-border: transparent;\n    --scale-square: #eef0f5;\n    --page-bg: #fff !important;\n    --ant-check-bg: var(--question-bg);\n    --input-bg: transparent;\n    --ending-bg: #fff;\n    --btn-text: #fff;\n    --checkbox-disabled-color: #ccc;\n    --title-sticky-bg: #fff;\n    --mobile-footer-bg: var(--page-bg); \n    --mobile-option-bg: rgba(22, 24, 35, 0.03);\n    --mobile-check-bg: rgba(5, 50, 250, 0.06);\n    --mobile-check-border:#0532FA;\n    --mobile-entity-bg: rgba(22, 24, 35, 0.05);\n    --mobile-matrix-header-bg: #EDEDEE;\n  };\n  .am-image-picker-upload-btn {\n    background: var(--mobile-option-bg) !important;\n    border: 0 !important;\n    border-radius: 8px !important;\n    &::before {\n      width: 2px !important;\n      height: 18px !important;\n      background: rgba(22, 24, 35, 0.6) !important;\n\n    }\n    &::after {\n      width: 18px !important;\n      height: 2px !important;\n      background: rgba(22, 24, 35, 0.6) !important;\n    }\n  }\n  .am-image-picker-item-content {\n    border-radius: 8px !important;\n  }\n  .am-image-picker-item-remove {\n    height: 20px !important;\n    width: 20px !important;\n    top: 0px !important;\n    right: 0px !important;\n    border-radius: 0 8px 0 0 !important;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHeSURBVHgB7Zgxa8JAGIbvElpMCzWh6GJBRSiIxam4d6lCu3fXX9AO+hMchHZ20LW/wLEdnNutuDgIbYpjdLBFDLH3lQZampi73IUeJQ9oTsldHs679z7ExWLxAkmMgiQnFuQlFuQlFuQlFuTlfwnm8/mdbrd7Bi9oR90PUFOp1BHtze12+7RSqZxnMpnDarVaGg6Hj7PZbIUC5Hq93mWhUDiGfrlcbjUYDMaIEqYZXK/X2G3run4AD940I64c3Os1hnDBTqdzN5/PTUQh6SVHZtskY9wjBpgEJ5PJe71evw6S9JNrNBo3ZIw3xADTGvx6kE3W3kOtVislEok9+A6u7po0DGNLlByAwxasZJa0fr9/lUwmf4jAVZQcEDoH/X5ukXJcgn6SIuUAEScJJtGBooJL0Gu3utDkJA2hBf2ihDYnIxXclHM0ORmpYFAI04Z5JIK0J4RISSbBZrN5QptzfpIwBmIgdDVDk3NekqzVDNNZPBqNXqCeM01z3Gq1bmlC2D273X5QzQTVkN/B8Z9HnMSCvCiqqi6QxCiO47wiiVGWy6XUgqplWYt0Or1N2vtIQj43iaZpTyThLSQhKrxNp1Mnm80+27YNn6WayV/nYrlc3iWiJbJ5dIyxgf6YD1D8aYa/g9ymAAAAAElFTkSuQmCC) !important;\n  }\n\n  ";
export var getCustomizedHTML = function getCustomizedHTML(customizedTheme) {
  return "html {\n    --primary-color: ".concat(customizedTheme.primaryColor, ";\n    --title-color: ").concat(customizedTheme.textColor, ";\n    --text-color: ").concat(customizedTheme.textColor, ";\n    --text-color-secondary: ").concat(customizedTheme.textColorSecondary, ";\n    --question-bg: ").concat(customizedTheme.questionBg, ";\n    --ant-table-hover: ").concat(customizedTheme.antTableHover, ";\n    --ant-menu-hover: ").concat(customizedTheme.antMenuHover, ";\n    --ant-bg: ").concat(customizedTheme.antBg, ";\n    --ant-border: ").concat(customizedTheme.antBorder, ";\n    --ant-entity-bg: ").concat(customizedTheme.antEntityBg, ";\n    --am-entity-bg: ").concat(customizedTheme.amEntityBg, ";\n    --ant-entity-border: ").concat(customizedTheme.antEntityBorder, ";\n    --ant-table-border: ").concat(customizedTheme.antTableBorder, ";\n    --scale-square: ").concat(customizedTheme.scaleSquare, ";\n    --page-bg: ").concat(customizedTheme.backgroundColor, ";\n    --ant-check-bg: ").concat(customizedTheme.antCheckBg || 'var(--question-bg)', ";\n    --input-bg: ").concat(customizedTheme.inputBg, ";\n    --ending-bg: ").concat(customizedTheme.endingBg, ";\n    --btn-text: ").concat(customizedTheme.btnText, ";\n    --checkbox-disabled-color: ").concat(customizedTheme.checkboxDisabledColor, ";\n    --title-sticky-bg: ").concat(customizedTheme.titleStickyBg, ";\n    --mobile-footer-bg: ").concat(customizedTheme.mobileFooterBg, ";\n  }");
};
export var colorRgb = function colorRgb(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var sColor = color.toLowerCase();
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#';
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    // 处理六位的颜色值
    var sColorChange = [];
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x".concat(sColor.slice(i, i + 2))));
    }
    sColorChange[1] = sColorChange[1] + 22;
    return "rgba(".concat(sColorChange.join(','), ", ").concat(opacity, ")");
  }
  return sColor;
};
export var getCustomizedHTMLByQuestBgColor = function getCustomizedHTMLByQuestBgColor(quest, questBgColor) {
  return "html {\n    --primary-color: ".concat(quest.primaryColor || '#3370ff', " !important;\n    --title-color: ").concat(quest.textColor && quest.textColor != 'rgba(0, 0, 0, 0.65)' ? quest.textColor : '#161823', " !important;\n    --text-color: ").concat(quest.textColor && quest.textColor != 'rgba(0, 0, 0, 0.65)' ? quest.textColor : 'rgba(22, 24, 35, 0.75)', " !important;\n    --text-color-secondary: ").concat(quest.textColor && quest.textColor != 'rgba(0, 0, 0, 0.65)' ? quest.textColor : '', " !important;\n    --question-bg: ").concat(questBgColor, " !important;\n    --ant-table-hover: ").concat(questBgColor, " !important;\n    --ant-menu-hover: ").concat(questBgColor, " !important;\n    --ant-bg: none !important;\n    --ant-border: ").concat(quest.textColor && quest.textColor != 'rgba(0, 0, 0, 0.65)' ? quest.textColor : '', " !important;\n    --ant-entity-bg: ").concat(questBgColor, " !important;\n    --am-entity-bg: ").concat(questBgColor === '#fff' || questBgColor === 'rgba(255,255,255,1)' ? '#eef0f5' : 'rgba(255,255,255,0.3)', " !important;\n    --ant-entity-border: none !important;\n    --ant-table-border: ").concat(questBgColor, " !important;\n    --scale-square: ").concat(questBgColor === '#fff' || questBgColor === 'rgba(255,255,255,1)' ? '#eef0f5' : 'rgba(255,255,255,0.3)', " !important;\n    --page-bg: false !important;\n    --ant-check-bg: ").concat(questBgColor, " !important;\n    --input-bg: none !important;\n    --ending-bg: ").concat(questBgColor, " !important;\n    --btn-text: #fff !important;\n    --checkbox-disabled-color: #ccc !important;\n    --title-sticky-bg: ").concat(questBgColor, " !important;\n  }");
};
export var languageOpts = [{
  label: '简体中文',
  cnLabel: '简体中文',
  value: 'cn'
}, {
  label: '繁體中文',
  cnLabel: '繁体中文',
  value: 'tc'
}, {
  label: 'English',
  cnLabel: 'English',
  value: 'en'
}, {
  label: '日本語',
  cnLabel: '日本语',
  value: 'ja'
}, {
  label: '한국인',
  cnLabel: '韩国语',
  value: 'ko'
}, {
  label: 'Português',
  cnLabel: '葡萄牙语',
  value: 'pt'
}, {
  label: 'Deutsch',
  cnLabel: '德语',
  value: 'de'
}, {
  label: 'Français',
  cnLabel: '法语',
  value: 'fr'
}, {
  label: 'Italiano',
  cnLabel: '意大利语',
  value: 'it'
}, {
  label: 'हिंदी',
  cnLabel: '印地语',
  value: 'hindi'
}, {
  label: 'தமிழ்',
  cnLabel: '泰米尔语',
  value: 'ta'
}, {
  label: 'తెలుగు',
  cnLabel: '泰卢固语',
  value: 'te'
}, {
  label: 'മലയാളം',
  cnLabel: 'Malayalam',
  value: 'ml'
}, {
  label: 'ಕನ್ನಡ',
  cnLabel: 'Kannada',
  value: 'kn'
}, {
  label: 'मराठी',
  cnLabel: 'Marathi',
  value: 'mr'
}, {
  label: 'ગુજરાતી',
  cnLabel: 'Gujarati',
  value: 'gu'
}, {
  label: 'Bengali',
  cnLabel: 'Bengali',
  value: 'bn'
}, {
  label: 'ਪੰਜਾਬੀ',
  cnLabel: 'Punjabi',
  value: 'pa'
}, {
  label: 'भोजपुरी',
  cnLabel: 'Bhojpuri',
  value: 'bh'
}, {
  label: 'Bahasa Indonesia',
  enLabel: 'Bahasa Indonesia',
  value: 'id'
}, {
  label: 'العربية',
  cnLabel: '阿语العربية',
  value: 'ar'
}, {
  label: 'Türkçe',
  enLabel: '土耳其语',
  value: 'tr'
}, {
  label: 'മലേഷ്യൻ',
  cnLabel: '马来西亚语',
  value: 'my'
}, {
  label: 'Русский',
  cnLabel: '俄语',
  value: 'Russian'
}, {
  label: 'español',
  cnLabel: '西班牙语',
  value: 'Spanish'
}, {
  label: 'แบบไทย',
  cnLabel: '泰语',
  value: 'Thai'
}, {
  label: 'Tiếng Việt',
  cnLabel: '越南语',
  value: 'Vietnamese'
}, {
  label: 'Filipino',
  cnLabel: '菲律宾语',
  value: 'Filipino'
}];